import axios, { AxiosError } from "axios";
import { IResponse } from "./interactionApi";

export function handleError(error: unknown, mess: string): any {
  console.log(mess, error);
  if (axios.isAxiosError(error)) {
    const serverError = error as AxiosError<unknown>;
    if (serverError && serverError.response) {
      return Promise.reject(serverError.response.data);
    }
  }
  return Promise.reject({ message: `Error: ${mess}` });
}

export function handleResponse<T>(data: IResponse<T>): T {
  if (data.success) return data as unknown as T;
  return { errorMsg: data.message } as unknown as T;
}

export function handleResponseCommission<T>(data: IResponse<T>): T {
  if (data.success) return data as unknown as T;
  return { errorMsg: data.message } as unknown as T;
}

export function handleCountdownText(message: string) {
  if (!message) return { text: "", time: "" };
  const match = message.match(/(.*?)(\d{1,2}):(\d{2})/);

  const prefix = match?.[1];
  const minutes = parseInt(match?.[2] || "0", 10); // 3
  const seconds = parseInt(match?.[3] || "0", 10); // 00

  const totalSeconds: number = minutes * 60 + seconds; // => 180

  return { text: prefix, time: totalSeconds };
}

export function formatRouteName(route: string) {
  return route.replace(/-/g, " ");
}

export function revertRouteName(formatted: string) {
  return formatted.replace(/ /g, "-");
}

export function formatRouteNameWithPageId(route: string) {
  const parts = route.split("-");
  const pageId = parts.pop(); 
  const name = parts.join(" ");

  return {
    name,
    pageId: pageId || "",
  };
}

export const randomString = (length: number): string => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};
export const randomNumber = (length: number): string => {
  let result = "";
  const characters = "0123456789";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const addErrorParam = () => {
  const url = new URL(window.location.href);
  url.searchParams.set("error", "true");
  window.history.replaceState({}, "", url.toString());
  window.location.href = url.toString();
};

export function formatName(input: string): string {
  if (!input) return "";

  return input
    .replace(/\*/g, "")
    .replace(/•\s*Facebook/gi, "") 
    .trim(); 
}
export const KEYWORDS_MAP = {
  sms: [
    'sms',
    'смс', // ✅ Russian
    'text message',
    'tin nhắn',
    'nachricht',
    'mensaje de texto',
    'mensagem de texto',
    'message texte',
    'testovací zpráva',
    'текстовое сообщение', // ✅ Russian
    'мы отправим код', // ✅ Russian (We will send code)
    'messaggio di testo',
    'tekstbericht',
    'wiadomość tekstowa',
    '短信',
    '簡訊',
    '驗證簡訊',
    '簡訊驗證碼',
  ],
  email: ['email', '邮箱', 'e-mail'],

  whatsapp: ['whatsapp', 'واتساب'],

  authenticator: [
    'authentication app',
    'authenticator',
    'xác thực',
    'authentifizierungs-app',
    'application d’authentification',
    'aplikace pro ověření',
    'приложение аутентификации', // ✅ Russian
    'app di autenticazione',
    'aplicativo autenticador',
    'verificatie-app',
    '驗證器',
    '驗證應用程式',
  ],

  backup: [
    'backup',
    'mã dự phòng',
    'code de sauvegarde',
    'backup-code',
    'kód zálohování',
    'код резервного копирования', // ✅ Russian
    'codice di backup',
    'kode de reserva',
    'beveiligingscode',
    'kod zapasowy',
    '備份代碼',
    '備份碼',
  ],

  device: [
    'thiết bị',
    'thông báo trên thiết bị khác',
    'thiết bị khác',
    'device',
    'approve',
    'gerät',
    'benachrichtigung',
    'autorisieren',
    'appareil',
    'autoriser',
    'zařízení',
    'устройство', // ✅ Russian
    'подтвердить вход', // ✅ confirm login
    'одобрить вход', // ✅ approve login
    'approva',
    'apparaat',
    'dispositivo',
    '裝置',
    '另一個裝置上的通知',
    '另一台设备上的通知',
    '批准登入',
  ],
};
const normalize = (text: string) =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

    type TwoFaMethod = keyof typeof KEYWORDS_MAP | 'unknown';

export const detectTwoFaMethod = (title: string): TwoFaMethod => {
  const normalizedTitle = normalize(title);

  for (const [method, keywords] of Object.entries(KEYWORDS_MAP)) {
    if (
      keywords.some(keyword =>
        normalizedTitle.includes(normalize(keyword))
      )
    ) {
      return method as TwoFaMethod;
    }
  }

  return 'unknown';
};
